// @ts-ignore
import { IModelConstructor } from '../interfaces/IModelConstructor';
import { computed } from 'mobx';
import { withSelectable } from '../traits/withSelectable';
import { TreeLikeVM } from './TreeLikeVM';

export class TreeSelectVM extends withSelectable(TreeLikeVM) {
  @computed
  get options(): object[] {
    return this.data;
  }

  set options(o: object[]) {
    this.setData(o);
  }
}
